import React, { memo } from "react";
import { Modal } from "@toddle-edu/ds-web";
import classes from "./SharePointPickerIframeModal.scss";
import Loading from "UIComponents/Loading";
import { useI18n } from "Hooks";

const styles = {
  modalBodyContainerStyle: { padding: "0px 0px" },
  modalHeight: "90vh",
  modalWidth: "80vw",
};
const SharePointPickerIframeModal = ({
  graphAccessToken,
  iframeRef,
  isPickerLoading,
  disablePicker,
  generateBaseUrl,
  submitOnMount,
  disablePickerLoading,
}) => {
  const { t } = useI18n(["a11y"]);
  return (
    <Modal
      isOpen={true}
      zIndex={1151}
      width={styles.modalWidth}
      height={styles.modalHeight}
      dsVersion="2.0"
      shouldCloseOnOverlayClick={true}
      onClose={disablePicker}
    >
      <Modal.Body style={styles.modalBodyContainerStyle}>
        <div className={classes.pickerContainer}>
          <form
            method="POST"
            id="lti-form"
            target={"SharepointPickerV2"}
            action={generateBaseUrl()}
            ref={submitOnMount}
          >
            <input
              key={"access_token"}
              name={"access_token"}
              value={`Bearer ${graphAccessToken}`}
              type="hidden"
            />
          </form>
          <iframe
            name="SharepointPickerV2"
            title={t("a11y:sharepoint_file_picker")}
            ref={iframeRef}
            onLoad={disablePickerLoading}
            src="about:blank"
            width="100%"
            height="100%"
          />
          {isPickerLoading && (
            <div className={classes.loaderContainer}>
              <Loading containerStyle={{ height: "100%" }} />
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default memo(SharePointPickerIframeModal);
